export enum AuthenticationResponseCode {
  LoginGuard = 301,
  RequireRecaptchaV2 = 306,
  RecaptchaLowScore = 307,
  AccountLocked = 423,
}
